export default __webpack_public_path__ + "static/media/70-min.a624fa8c.jpg";